import { format } from 'date-fns';
import React from 'react';
import { Column } from '../../../../hooks/useTablePages';
import { constantToLabel } from '@ecosconnect/core/src/helpers/string';
import { JobItem } from './HazardSurveys.query';

export const columns: Column[] = [
  {
    header: 'Job',
    accessor: 'id',
    width: 75,
  },
  {
    header: 'Service #',
    accessor: 'waterHazardSurvey.waterService.siteNumber',
    width: 200,
  },
  {
    header: 'Status',
    id: 'outboundAssignment.status',
    accessor: (row: JobItem) => {
      return row.outboundAssignment?.status
        ? constantToLabel(row.outboundAssignment.status)
        : '';
    },
    width: 100,
  },
  {
    header: 'Assigned to',
    accessor: 'outboundAssignment.vendorProfile.name',
    width: 140,
  },
  {
    header: 'Created',
    id: 'created',
    accessor: (row: JobItem) => {
      return row.created ? format(row.created, 'M/d/yyyy') : '';
    },
    width: 100,
  },
  {
    header: 'Contact',
    accessor: 'waterHazardSurvey.contact.name',
    width: 190,
  },
  {
    header: 'Contact Phone',
    id: 'waterHazardSurvey.contact.phones.value',
    accessor: (row: JobItem) => {
      return row.waterHazardSurvey?.contact?.phones[0]?.value ?? '';
    },
    width: 130,
  },
  // {
  //  header: 'Test Date',
  //   id: 'job.backflowTest.dateTested',
  //   accessor: (row: JobItem) => {
  //     if (!row.job.backflowTest?.dateTested) {
  //       return ''
  //     }
  //     return format(parseISO(row.job.backflowTest.dateTested), 'M/d/yyyy')
  //   },
  //   width: 100,
  // },
  {
    header: 'Address',
    id: 'address.street1',
    accessor: (row: JobItem) =>
      row.address.street1 +
      (row.address.street2 ? ', ' + row.address.street2 : ''),
    width: 250,
  },
  {
    header: 'City',
    accessor: 'address.city',
    width: 120,
  },
  {
    header: 'State',
    accessor: 'address.state',
    width: 80,
  },
  {
    header: 'Zip',
    id: 'address.zip',
    accessor: (row: JobItem) =>
      row.address.zip + (row.address.zipExt ? '-' + row.address.zipExt : ''),
    width: 120,
  },
];
